// extracted by mini-css-extract-plugin
export default {"title":"EditableTitleForm-module_title_J5N4U","form-margin":"EditableTitleForm-module_form-margin_psQC7"};